import { render, staticRenderFns } from "./ProductTaxesEditFostplusEditItem.vue?vue&type=template&id=13ae4966&scoped=true"
import script from "./ProductTaxesEditFostplusEditItem.vue?vue&type=script&lang=ts"
export * from "./ProductTaxesEditFostplusEditItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae4966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ae4966')) {
      api.createRecord('13ae4966', component.options)
    } else {
      api.reload('13ae4966', component.options)
    }
    module.hot.accept("./ProductTaxesEditFostplusEditItem.vue?vue&type=template&id=13ae4966&scoped=true", function () {
      api.rerender('13ae4966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ProductTaxesEditFostplusEditItem.vue"
export default component.exports